import { useEffect } from 'react';
import { useGoogleOneTapLogin } from '@react-oauth/google';
import { useAuth } from '../contexts/AuthContext';

/**
 * Silent authentication component that enables One Tap sign-in
 * to automatically re-authenticate users when their session is about to expire
 * or when they return to the app.
 */
const SilentAuth = () => {
  const { signIn, isAuthenticated, sessionExpired, isLoading } = useAuth();

  // Enable One Tap sign-in for silent re-authentication
  useGoogleOneTapLogin({
    onSuccess: async (credentialResponse) => {
      if (credentialResponse.credential) {
        console.log('One Tap sign-in successful, refreshing session');
        await signIn(credentialResponse.credential);
      }
    },
    onError: () => {
      console.log('One Tap sign-in failed or was dismissed');
    },
    // Only show One Tap if:
    // 1. Not currently loading authentication state, AND
    // 2. User is not authenticated, OR session has expired (needs re-authentication)
    // This prevents showing One Tap during the initial auth check on page load
    disabled: isLoading || (isAuthenticated && !sessionExpired),
    // Auto-select account if only one Google account is available
    auto_select: sessionExpired,
    // Show One Tap prompt after a short delay when session expires
    promptMomentNotification: (notification) => {
      console.log('One Tap prompt:', notification.getMomentType());
    },
  });

  // Additional effect to trigger One Tap when session expires
  useEffect(() => {
    if (sessionExpired) {
      console.log('Session expired, One Tap will attempt silent re-authentication');
    }
  }, [sessionExpired]);

  // This component doesn't render anything
  return null;
};

export default SilentAuth;
